import loginedApi from "../apis";
import { SPECIALITY_LISTING } from "./type";
import specialist from "../specialityList";
import CryptoJS from "crypto-js";
var hashcode = CryptoJS.SHA256(
  process.env.REACT_APP_PREFIX +
    process.env.REACT_APP_TOKEN +
    process.env.REACT_APP_SECRETKEY
);

const publicIp = require("public-ip");
let IP = publicIp.v4();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B");
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D");
} //replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`

export const fetchSpeciality = (clientId) => async (dispatch) => {
  let countrycoderes = await loginedApi.post("getcountrycode",
    {
      token :hashcode.toString(),
      "version": "2.0",
      "data": { browserTimeZone: `GMT${formatTime}`, },
      "requestType": 1058
    });

 let doctorscountrycode = countrycoderes.data.data;

  const res = await loginedApi.post("getclinicspeciality", {
    token: hashcode.toString(),
    data: {
      clinicId: clientId,
      Ipaddress: IP,
      Os: platform,
      useragent: userAgent,
      accessCountry: doctorscountrycode.Country,
      currency: doctorscountrycode.currency,
    },
    requestType: 268,
  });
  //API caaling for continious blinking of data

  if (res.status === 200) {
    dispatch({
      type: SPECIALITY_LISTING,
      payload: res.data.data,
    });
  }
 
  console.debug('action', res)
  return res;
};

export const fetchallSpeciality = (clientId) => async (dispatch) => {
  const res = await loginedApi.post("getspecality", {
    token: hashcode.toString(),
    data: {
      clinicId: clientId,
      Ipaddress: IP,
      Os: platform,
      useragent: userAgent,
    },
    requestType: 268,
  });
  //API caaling for continious blinking of data
  if (res.status === 200) {
    dispatch({
      type: SPECIALITY_LISTING,
      payload: res.data.data,
    });
  }
};

export const fetchgangaSpeciality = (specialityId) => async (dispatch) => {
  const res = await loginedApi.post("getgangaspeciality", {
    token: hashcode.toString(),
    data: {
      specialityId: specialityId,
      Ipaddress: IP,
      Os: platform,
      useragent: userAgent,
    },
    requestType: 288,
  });
  //API caaling for continious blinking of data
  if (res.status === 200) {
    dispatch({
      type: SPECIALITY_LISTING,
      payload: res.data.data,
    });
    return res.data.data;
  }
};


export const fetchSpecialityDoctors = (specialityId) => async (dispatch) => {
  const res = await loginedApi.post("getdoctorsbyspeciality", {
    token: hashcode.toString(),
    data: {
      specialityId: specialityId,
      Ipaddress: IP,
      Os: platform,
      useragent: userAgent,
    }, 
    requestType: 288,
  });
  //API caaling for continious blinking of data
  if (res.status === 200) {
    dispatch({
      type: SPECIALITY_LISTING,
      payload: res.data.data,
    });
    return res.data.data;
  }
};
